import { getActionText } from '@bingads-webui-campaign-legacy/adextension-actionlink/model/language-type-text-mapper';


export const actionTextLocalization = (language, actionType) => {
  const ctaInfo = {
    Language: language,
    ActionType: actionType,
  };

  return getActionText(ctaInfo);
};
